import { useUsersQuery } from './useUsersQuery';

import { createMutationHook } from '~/shared/providers/api';

export interface CoreUsersEnableBulkMutationParams {
  userIds: string[];
}

export const useCoreUsersEnableBulkMutation = createMutationHook(
  'settings.teamPermissions.usersEnable',
  (params: CoreUsersEnableBulkMutationParams) => ({
    coreUsersEnable: {
      __args: {
        input: {
          userIds: params.userIds,
        },
      },
      successCount: true,
      failedCount: true,
      failedIds: true,
    },
  }),
  {
    invalidateQueries: [useUsersQuery],
  },
);
